import PropTypes from 'prop-types';
import Page from '../layouts/pages/Page';

/**
 *  @type React.FC<PropTypes.InferType<Container.propTypes>>
 *  @deprecated
 */
const Container = ({
  children,
}) => {
  return (
    <Page className="flex flex-col">
      {children}
    </Page>
  );
};

Container.propTypes = {
  header: PropTypes.bool,
  showBackButton: PropTypes.bool,
  backButtonLink: PropTypes.string,
  showProfile: PropTypes.bool,
  showNotifications: PropTypes.bool,
  background: PropTypes.string,
  iconcolor: PropTypes.string,
  elevate: PropTypes.bool,
  footer: PropTypes.bool,
  tabMenu: PropTypes.bool,
  sidebar: PropTypes.bool,
  sidebarExtra: PropTypes.bool,
  desktopHeader: PropTypes.bool,
  footercolor: PropTypes.string,
  footerbackground: PropTypes.string,
  contentstyle: PropTypes.object,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node), // as you can render an array of elements
    PropTypes.node, // for a single component/element
  ]).isRequired,
};

export default Container;
